<script>
    let cls = "sui-input";
    export let type = "text";
    export let disabled = false;
    export let readonly = false;
    export let placeholder = "";
    export let value = "";
    export let max = Number.MAX_SAFE_INTEGER;
    export let min = Number.MIN_SAFE_INTEGER;
    export let id = "";
</script>

<div class={cls}>
    {#if type === "password"}
        <input
            type="password"
            {id}
            {disabled}
            {readonly}
            {placeholder}
            bind:value={value}
            class={`${cls}-element`}
        />
    {:else if type === "number"}
        <input
            type="number"
            {id}
            {disabled}
            {readonly}
            {placeholder}
            {max}
            {min}
            bind:value={value}
            class={`${cls}-element`}
        />
    {:else}
        <input
            type="text"
            {id}
            {disabled}
            {readonly}
            {placeholder}
            bind:value={value}
            class={`${cls}-element`}
        />
    {/if}
</div>

<style lang="less">
    @import "./input.less";
</style>
